const BYTE = 1;
const KB = 1024;
const MB = 1024 * KB;
const GB = 1024 * MB;
const TB = 1024 * GB;
const PB = 1024 * TB;

export const fileSizeToBytes = {
  fromBytes: (n: number) => n * BYTE,
  fromKB: (n: number) => n * KB,
  fromMB: (n: number) => n * MB,
  fromGB: (n: number) => n * GB,
  fromTB: (n: number) => n * TB,
  fromPB: (n: number) => n * PB,
};
